import './view.scss';

function updateHeaderPosition() {
    const footerBottom = document.querySelector('.footer__bottom .col-12');
    const headerContent = document.querySelector('.header__content');

    if (!footerBottom || !headerContent) return;

    const footerRect = footerBottom.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (footerRect.bottom <= viewportHeight) {
        const overlapAmount = viewportHeight - footerRect.bottom;
        headerContent.style.bottom = `${overlapAmount}px`;
    } else {
        headerContent.style.bottom = '';
    }
}

window.addEventListener('scroll', updateHeaderPosition);

document.addEventListener('DOMContentLoaded', updateHeaderPosition);